import Text from "@src/lib/ui/Text";
import { FC } from "react";
import LightbulbOutlineIcon from "@src/lib/icons/18px/lightbulb-outline";

type Props = {
  tipCopy?: string;
};

const MultiSelectProTipBanner: FC<Props> = ({
  tipCopy = "Multi-select items in the library to grant access in bulk",
}) => {
  return (
    <div
      className="mt-4 mb-3 flex items-start justify-center gap-1 rounded-2xl bg-gray-4-alpha p-2 pr-3"
      style={{
        maxWidth: 475,
      }}
    >
      <div className="flex size-5 items-center justify-center">
        <LightbulbOutlineIcon className="size-4" />
      </div>
      <Text variant="compact-description" multiline>
        <strong>Pro tip:</strong> {tipCopy}
      </Text>
    </div>
  );
};

export default MultiSelectProTipBanner;
